import { FieldDiffStatus } from '../configs'

interface IGetFieldDiffStatusParams {
  isDifferent?: boolean
  isEmpty?: boolean
}
export const getFieldDiffStatus = (field: IGetFieldDiffStatusParams) => {
  switch (true) {
    case field.isEmpty:
      return FieldDiffStatus.Empty
    case field.isDifferent:
      return FieldDiffStatus.Diff
    default:
      return FieldDiffStatus.Match
  }
}
